import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface NewProfileCardHeader {
  title: string;
  icon: IconProp;
}

const NewProfileCardHeader = ({ title, icon }: NewProfileCardHeader) => {
  return (
    <div className="self-stretch inline-flex flex-col justify-center items-start gap-1">
      <div className="inline-flex justify-start items-center gap-1.5">
        <div className="flex justify-start items-center gap-1.5">
          <div data-property-1="lg" className="w-6 h-6 relative">
            <div className="w-6 h-6 flex items-center justify-center">
              <Icon icon={icon} size="lg" className="w-5 h-5 text-secondary" />
            </div>
          </div>
          <div className="justify-start text-primary text-lg font-bold font-['Inter'] leading-7">
            {title}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProfileCardHeader;
